<template lang="pug">
nav.d-flex.flex-wrap.justify-end
  template(v-for="(route, i) in menu")
    v-btn.main-header-btn.text-caption.text-xl-body-1.font-weight-bold.px-1(
      v-if="route.name != 'Produtos'",
      :key="i",
      :to="route.path",
      color="secondary",
      exact-active-class="main-header-btn-active",
      text
    ) {{ route.name }}
    v-menu(v-else, offset-y, tile, max-height="60vh")
      template(v-slot:activator="{ on, attrs }")
        v-btn.main-header-btn.text-caption.text-xl-body-1.font-weight-bold.px-1(
          v-bind="attrs",
          v-on="on",
          color="secondary",
          exact-active-class="main-header-btn-active",
          text
        ) {{ route.name }}
          v-icon.ml-3(size="12") fa-caret-down

      v-list(tile)
        v-list-item(
          v-for="{ text, to } in categories",
          :key="to",
          exact,
          :to="to"
        )
          v-list-item-title.grey--text.text--darken-3 {{ text }}
    v-divider.my-2.mx-3.secondary.lighten-2(
      v-if="i + 1 !== menu.length",
      vertical
    )
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.$rest("products-categories").get();
  },
  computed: {
    categories() {
      return this.$rest("products-categories").list.map(({ id, title }) => ({
        text: title,
        to: "/produtos?c=" + id,
      }));
    },
  },
};
</script>

<style>
.main-header-btn {
  position: relative;
}
.main-header-btn-active::before {
  background-color: transparent !important;
}
.main-header-btn::after {
  content: "";
  display: block;
  background: var(--v-primary-base);
  height: 2px;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0%;
  transition: 0.5s;
  margin: 0px 5px;
}
.main-header-btn-active::after {
  left: 0px;
  width: calc(100% - 10px);
}
</style>
